<template>
  <Select
    :items="opcoes"
    :selectedItem="filter.simNao"
    :label="filtro.name"
    searchPlaceholder="Buscar opção"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :id="filtro.filtro"
    :path="path"
    :fixo="filtro.fixo"
    :class="{ 'sem-opcao-vazia': padrao }"
  />
</template>
<script>
import Select from '../../components/Select.vue';

const VALORES_DO_CHECKBOX_LEGADO = { 1: 'true', 0: 'false' };

export default {
  components: {
    Select
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filter: {
        simNao: {
          id: '',
          name: ''
        }
      },
      opcoes: [
        { id: 'true', name: 'Sim' },
        { id: 'false', name: 'Não' }
      ]
    };
  },
  computed: {
    padrao() {
      return this.filtro.parametros?.padrao ?? '';
    }
  },
  methods: {
    atualizar(opcao) {
      const vazioComPadrao = opcao.id === '' && this.padrao;
      this.filter.simNao = vazioComPadrao ? { ...this.opcoes.find(item => item.id === this.padrao) } : opcao;

      if (opcao.id === '' || opcao.id === this.padrao) {
        this.$removeFiltroDaURL(this.filtro.filtro, this.path);
        this.$store.commit('removeFiltroAplicado', this.filtro.filtro);
        return;
      }

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.simNao.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.simNao.id
      });
    }
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro] ?? this.padrao;
    const valor = VALORES_DO_CHECKBOX_LEGADO[filtroAplicado] ?? filtroAplicado;
    this.$renderFiltroSelect(valor, this.opcoes, this.filter.simNao);
  }
}
</script>
